<template>
  <div class="c-latest-advisory">
    <sc-text
      v-if="fields && fields.heading"
      tag="h3"
      class="c-latest-advisory__headline"
      :field="fields.heading"
    />
    <div v-if="fields && fields.resourceTitle" class="c-latest-advisory__title">
      <sc-text v-if="fields && fields.resourceTitle" :field="fields.resourceTitle" />
    </div>
    <div v-if="date" class="c-latest-advisory__date">{{ date }}</div>
    <div v-if="overview" class="c-latest-advisory__desc">{{ overview }}</div>
    <sc-link
      v-if="fields && fields.link"
      :field="fields.link"
      class="c-cta--secondary"
      :class="fields.link.value.class"
    />
  </div>
</template>

<script>
import { Link, Text } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Latest-Advisory',
  components: {
    ScLink: Link,
    ScText: Text
  },
  props: {
    fields: {
      type: Object
    }
  },
  computed: {
    date() {
      const date = new Date(this.fields?.publishedAt?.value);

      return (
        date.getDate() +
        ' ' +
        date.toLocaleString('en-US', { month: 'short' }) +
        ' ' +
        date.getFullYear()
      );
    },
    overview() {
      var description = this.fields?.overview.value;

      // Remove HTML tags
      var descriptionClean = description.replace(/<[^>]+>/g, '').trim();

      return descriptionClean.length > 0 && descriptionClean.length > 145
        ? descriptionClean.substr(0, 145) + '...'
        : descriptionClean;
    }
  }
};
</script>
<style lang="scss" scoped>
.c-latest-advisory {
  clear: both;
  border: solid 1px $lite-gray;
  padding: 2rem;

  &__title {
    font-weight: 500;
    margin-bottom: 1rem;
  }

  &__headline {
    font-weight: 500;
  }

  &__date {
    font-weight: 500;
  }

  &__desc {
    @include font-styles('Arial', 2rem, 300, normal, 3rem, 0, $gray);
    display: block;
    margin-bottom: 2rem;
  }

  .c-cta--secondary {
    margin-bottom: 0;
  }
}
</style>
